
import Loading from 'vux/src/components/loading/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

export default {
components: {
Loading,
XTable,
Confirm
},
data() {
return {
courseLists: [],
noteLists: []
}
},
mounted() {

this.$vux.loading.show({
text: 'Loading'
})


this.$api.GetNoteCourse()
.then((data) => {
if (data.data.Status != 0) {
return;
}

var courseList = data.data.Data;

this.$api.GetCourse(courseList)
.then((datalist) => {
if (datalist.data.Status != 0) {
return;
}
var list = datalist.data.Data;

var datalist = new Array();
for (var item in list) {
var oneData = {
IDCode: list[item].IDCode,
Name: list[item].Name
}

datalist.push(oneData)
}

this.courseLists = datalist;
})

})

this.$api.GetNoteList()
.then((data) => {
if (data.data.Status != 0) {
return;
}
var courseList = data.data.Data.rows;

this.noteLists = courseList;
})


setTimeout(() => {
this.$vux.loading.hide()
}, 500)

},
methods: {

clickDelete: function() {

var id = event.target.id;
var deleteSure = confirm("确认删除？")

if (deleteSure) {
this.$api.DeleteNote(id)
.then((data) => {
if (data.data.Status == 0) {

this.$api.GetNoteList()
.then((data) => {
if (data.data.Status != 0) {
return;
}
var courseList = data.data.Data.rows;

this.noteLists = courseList;
})
}
})
}



},

foldUnfold: function() {

this.$api.GetNoteList()
.then((data) => {
if (data.data.Status != 0) {
return;
}
var courseList = data.data.Data.rows;

this.noteLists = courseList;
})

var test = document.getElementById(event.target.id); 
var foldingbox = test.nextElementSibling; 
var foldinglogo = test.previousElementSibling; 

if (foldingbox.className == "folding-show") {
foldingbox.classList.add("folding-close");
foldingbox.classList.remove("folding-show");
foldinglogo.innerHTML = "▼展开";
} else if (foldingbox.className == "folding-close") {
foldingbox.classList.add("folding-show");
foldingbox.classList.remove("folding-close");

foldinglogo.innerHTML = "▲收起";
}
},

JumpVideo(url, IDCode, ChapterID) {
var idlist = [];
idlist.push(ChapterID);
this.$api.GetRescourse(idlist)
.then((data) => {
if (data.data.Status != 0) {
return;
}
this.$router.push({
path: "/Index/Course",
name: "/Index/Course",
params: {
IDCode: IDCode,
ChapterID: data.data.Data[0].ChapterID,
level1: "我的收藏/",
}
})


})
},

}
}



// WEBPACK FOOTER //
// ./src/views/Personal/MyNotes.vue